import { useBrowserExtensionLoginParams } from './useBrowserExtensionLoginParams';
import { useClickOutside } from './useClickOutside';
import { useDebounce } from './useDebounce';
import { useDebounceFunctions } from './useDebounceFunctions';
import { useEscapeKey } from './useEscape';
import { useFBLActivate } from './useFBLActivate';
import { useFBLSpecialCoupon } from './useFBLSpecialCoupon';
import { useImageError } from './useImageError';

export const Hooks = {
  useClickOutside,
  useDebounce,
  useDebounceFunctions,
  useEscapeKey,
  useImageError,
  useFBLActivate,
  useFBLSpecialCoupon,
  useBrowserExtensionLoginParams,
};
